import { Point } from '../../platform/geom/Point';
import { PropertyValueType } from './Interfaces';

const tryDeserializeNumberList = (numbers: number[]) => {
    if (numbers.length < 2 || numbers.length % 2 !== 0) return null;
    const points = [] as Point[];
    for (let i = 0; i < numbers.length; i += 2) {
        const x = numbers[i];
        const y = numbers[i + 1];
        if (typeof x !== 'number' || typeof y !== 'number') {
            return null;
        }
        points.push(new Point(x, y));
    }
    return points;
};

export const PointTupleType: PropertyValueType<readonly Point[]> = Object.freeze({
    name: 'PointTuple',
    byRef: true,
    parse(value: string): readonly Point[] {
        const numbers = value.split(',').map(x => parseFloat(x) || 0);
        if (numbers.length < 2 || numbers.length % 2 !== 0) return null;
        return tryDeserializeNumberList(numbers);
    },
    fromString(value: string): [boolean, readonly Point[]] {
        const result = this.parse(value);
        return [result !== null, result];
    },
    serialize(value: readonly Point[]): any {
        return value.flatMap(p => [p.x, p.y]);
    },
    deserialize(value: any, defau1t?: readonly Point[]): readonly Point[] {
        if (!value) return defau1t;
        return tryDeserializeNumberList(value) ?? this.parse(value.toString()) ?? defau1t;
    },
});
